import React, {Fragment, useContext, useEffect, useState} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

const ObligadosPendientes = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [obligados, setObligados] = useState([])
  const [declaracionesJuradas, setDeclaracionesJuradas] = useState([])
  const [header, setHeader] = useState([]);
  const [query, setQuery] = useState({
    query: ""
  });

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'MesaEntrada'){
      setRenderHTML(true)
      fetchObligadosPendientes()
      fetchDeclaracionesJuradas()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchObligadosPendientes = async (sortBy='', q='', page=1, otro='') => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios/listadoObligadosPendientes', sortBy, q, page, otro);
      if (page === 1) {
        setObligados(data.data);
      } else {
        setObligados([...obligados, ...data.data]);
      }

      setHeader(data.headers);

    } catch (error) {
      errorMessage(error)
    }
  };

  const fetchDeclaracionesJuradas = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('declaraciones_juradas', 'listadoPendientes');
      setDeclaracionesJuradas(data)

    } catch (error) {
      errorMessage(error)
    }
  };

  const fetchDeclaracionesAprobadas = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('declaraciones_juradas', 'listadoAprobado');
      setDeclaracionesJuradas(data)

    } catch (error) {
      errorMessage(error)
    }
  };

  const fetchDeclaracionesRechazadas = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('declaraciones_juradas', 'listadoRechazado');
      setDeclaracionesJuradas(data)

    } catch (error) {
      errorMessage(error)
    }
  };

  const eliminarRegistroPDF = async (id) => {
    try {
      if(!window.confirm('Está seguro que quiere eliminarlo ?')){
        return;
      }

      await resourcesServices.eliminarResource('registro_pdfs', id);

      await fetchObligadosPendientes()

    } catch (error) {
      errorMessage(error)
    }
  };


  const aprobarDJ = async (id) => {
    try {
      if(!window.confirm('Está seguro que quiere aprobar la Declaración Jurada ?')){
        return;
      }

      await resourcesServices.actualizarResource('declaraciones_juradas', id, {declaracion_jurada: {estado: 'aprobado'}});
      await fetchDeclaracionesJuradas()


    } catch (error) {
      errorMessage(error)
    }
  };  

  const rechazarDJ = async (id) => {
    try {
      if(!window.confirm('Está seguro que quiere rechazar la Declaración Jurada ?')){
        return;
      }

      const motivo = window.prompt('Ingrese el motivo')

      await resourcesServices.actualizarResource('declaraciones_juradas', id, {declaracion_jurada: {estado: 'rechazado', motivo_rechazo: motivo}});
      await fetchDeclaracionesJuradas()


    } catch (error) {
      errorMessage(error)
    }
  };  

  const verUsuario = (obligado) => {
    if(obligado.preferencias_usuario){
      navigate(`/usuarioForm/${obligado.preferencias_usuario.usuario_id}`)
    } else {
      navigate(`/obligadoPendienteForm/${obligado.id}`)
    }
  }

  return (
    <div>
      <h1>Obligados Registrados <BotonVolver /></h1>
      {renderHTML && (
        <>
        <div className="card">
          <div className="card-body px-0 pb-2">

            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="tab-1" data-bs-toggle="tab" data-bs-target="#tab-pane-1" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">
                  Obligados
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="tab-2" data-bs-toggle="tab" data-bs-target="#tab-pane-2" type="button" role="tab" aria-controls="declaracion-tab-pane" aria-selected="false">
                  Declaraciones Juradas
                </button>
              </li>
            </ul>

            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="tab-pane-1" role="tabpanel" aria-labelledby="tab-1" tabIndex="0">
                <div className="table-responsive">
                  <table className="table align-items-center mb-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre y apellido</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Documento</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cargo / Organismo</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Teléfono</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha Reg. Web</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">PDF</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {obligados && obligados.map((obligado, index) => {
                        return (
                          <tr
                            className={`${ obligado.preferencias_usuario ? 'bg-warning bg-gradient' : '' }`}
                            key={index}
                            >
                            <td role="button" onClick={() => verUsuario(obligado)} >
                              {obligado.nombre} {obligado.apellido}
                            </td>
                            <td>
                              {obligado.documento_identidad}
                            </td>
                            <td className="align-middle text-center text-sm">
                              {
                                obligado.fields && obligado.fields.declaracion_juradas_attributes && (
                                  <>
                                    {obligado.fields.declaracion_juradas_attributes.cargo} <br /> {obligado.fields.declaracion_juradas_attributes.organismo}
                                  </>
                                )
                              }
                            </td>
                            <td className="align-middle">
                              {obligado.telefono}
                            </td>
                            <td className="align-middle">
                              {obligado.fechaRegistroWeb}
                            </td>
                            <td className="align-middle">
                              {
                                obligado.preferencias_usuario ? (
                                  <b>Obligado Creado</b>
                                ) : (
                                  obligado.archivoUrl && (
                                    <a href={obligado.archivoUrl} className='btn btn-success' target='_blank'>Ver Archivo</a>
                                  )
                                )
                              }
                            </td>
                            <td className="align-middle">
                              <button onClick={() => eliminarRegistroPDF(obligado.id)}  className='btn btn-danger'>Eliminar</button>
                            </td>
                          </tr>
                        )
                      })
                      }
                    </tbody>
                  </table>

                  {/* {
                    header["total-pages"] !== header["current-page"] && (
                      <div className='p-3'>
                        <button onClick={()=>obtenerPagina(header["current-page"] + 1)} className='btn btn-success mt-3'>Ver más | {header["current-page"]} de {header["total-pages"]}</button>
                      </div>
                    )
                  } */}
                </div>
              </div>
              <div className="tab-pane fade" id="tab-pane-2" role="tabpanel" aria-labelledby="tab-2" tabIndex="0">
                <div className="table-responsive">


                  <div className="btn-group m-3" role="group" aria-label="Basic example">
                    <button onClick={()=>fetchDeclaracionesJuradas()} type="button" className="btn btn-primary">Pendientes</button>
                    <button onClick={()=>fetchDeclaracionesAprobadas()} type="button" className="btn btn-primary">Aprobadas</button>
                    <button onClick={()=>fetchDeclaracionesRechazadas()} type="button" className="btn btn-primary">Rechazadas</button>
                  </div>

                  <table className="table align-items-center mb-0 table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Cargo | Organismo</th>
                        <th scope="col">Obligado</th>
                        <th scope="col">Desde | Norma legal</th>
                        <th scope="col">Hasta | Norma legal</th>
                        <th scope="col">Declaración Jurada</th>
                        <th scope="col">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      { declaracionesJuradas.map(declaracion_jurada => (
                        <Fragment key={declaracion_jurada.id}>
                          <tr>
                            <td>
                              <span className={`badge ${declaracion_jurada.estado === 'rechazado' ? 'text-bg-danger' : 'text-bg-secondary'}`}>
                              {declaracion_jurada.estado}</span> - <b>{declaracion_jurada.cargo}</b> | {declaracion_jurada.organismo}
                            </td>
                            <td>{declaracion_jurada.usuario && `${declaracion_jurada.usuario.nombre} ${declaracion_jurada.usuario.apellido}`}</td>
                            <td>{declaracion_jurada.f_cargo_desde_formated} | {declaracion_jurada.numero_alta_norma_legal}</td>
                            <td>{declaracion_jurada.f_cargo_hasta_formated} | {declaracion_jurada.numero_baja_norma_legal}</td>
                            <td>
                              {
                                declaracion_jurada.archivoUrl && (
                                  <Link to={declaracion_jurada.archivoUrl} className="btn btn-secondary" target='_blank'>Descargar</Link>
                                )
                              }
                            </td>
                            <td>
                              {
                                declaracion_jurada.estado === 'creado' && (
                                  <>
                                  <button onClick={() => aprobarDJ(declaracion_jurada.id)} className="btn btn-info" type='button'>Aprobar</button>
                                  <button onClick={() => rechazarDJ(declaracion_jurada.id)} className="btn btn-danger ms-1" type='button'>Rechazar</button>
                                  </>
                                )
                              }
                            </td>
                          </tr>
                          {
                            declaracion_jurada.estado === 'rechazado' && (
                              <tr>
                                <td colSpan={6} className='p-0'>
                                  <div className="alert alert-danger text-light" role="alert">
                                    <b>Motivo del rechazo:</b> {declaracion_jurada.motivo_rechazo}
                                  </div>
                                  </td>
                              </tr>
                            )
                          }
                        </Fragment>
                        ))
                      }
                    </tbody>
                  </table>


                </div>                
              </div>
            </div>


          </div>
        </div>

        </>
      )}
    </div>
  );
};

export default ObligadosPendientes;